import type { RouteObject } from 'react-router'

// auth
import { SignUp } from '../pages/auth/SignUp'
import { SignIn } from '../pages/auth/SignIn'
import { SignInVerify } from '../pages/auth/SignInVerify'
// home
import { Home } from '../pages/home/Home'
// market
import { Market } from '../pages/market/Market'
import { ProductDetail as MarketProductDetail } from '../pages/market/ProductDetail'

// contents
import { Contents } from '../pages/contents/Contents'
import { ContentDetail } from '../pages/contents/ContentDetail'

// setting
import { Setting } from '../pages/settings/Setting'
import { Notify } from '../pages/notification/Notify'
import { NoticeDetail } from '../pages/notification/NoticeDetail'
import { NoticeList } from '../pages/settings/notice/NoticeList'
import { EventList } from '../pages/settings/event/EventList'
import { EventDetail } from '../pages/settings/event/EventDetail'
import { News } from '../pages/settings/news/News'
import { Disclosure } from '../pages/settings/disclosure/Disclosure'
import { DisclosureDetail } from '../pages/settings/disclosure/DisclosureDetail'
import { Faq } from '../pages/settings/faq/Faq'

// terms
import { Privacy } from '../pages/terms/Privacy'

export const PUBLIC_ROUTES: RouteObject[] = [
  // home
  { path: '/', element: <Home /> },
  { path: '/home', element: <Home /> },

  // market
  { path: '/market', element: <Market /> },
  { path: '/market/product/:id', element: <MarketProductDetail /> },

  // contents
  { path: '/contents', element: <Contents /> },
  { path: '/contents/:articleId', element: <ContentDetail /> },

  // setting
  { path: '/setting', element: <Setting /> },
  { path: '/notify', element: <Notify /> },
  { path: '/notice', element: <NoticeList /> },
  { path: '/notice/:noticeId', element: <NoticeDetail /> },
  { path: '/event', element: <EventList /> },
  { path: '/event/:eventId', element: <EventDetail /> },
  { path: '/news', element: <News /> },
  { path: '/disclosure', element: <Disclosure /> },
  { path: '/disclosure/:disclosureId', element: <DisclosureDetail /> },
  { path: '/faq', element: <Faq /> },

  // sign
  { path: '/signUp', element: <SignUp /> },
  { path: '/signIn', element: <SignIn /> },
  { path: '/signIn/:provider', element: <SignInVerify /> },

  // privacy
  { path: '/privacy', element: <Privacy /> },
]
